export default "__VITE_ASSET__0IFRGbK5__"